import React from 'react'
import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet'

import Layout from '../components/layout'
import './not-found.css'

const NotFound = () => (
  <Layout>
    <Helmet>
      <title>Página no encontrada | Variant</title>
      <meta name="robots" content="noindex" />
    </Helmet>
    <section className="not-found container">
      <span className="not-found__code">404</span>
      <h1>No encontramos esta página</h1>
      <p>Puede que el enlace esté mal escrito o que la página ya no exista.</p>
      <div className="btn-row">
        <Link to="/" className="btn btn--primary">
          Ir al inicio
        </Link>
        <Link to="/secretario" className="btn btn--ghost">
          Conocer Secretario
        </Link>
      </div>
    </section>
  </Layout>
)

export default NotFound
